// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SimplifiedHeader{display:flex;justify-content:space-between;width:100%;padding:28px}.SimplifiedHeader .redirect-link{display:block}.SimplifiedHeader .mcp-logo{width:200px}@media(min-width:769px){.SimplifiedHeader .mcp-logo{width:auto}}.SimplifiedHeader .VerifiedReviews__container{display:none}@media(min-width:641px){.SimplifiedHeader{padding:0 28px}.SimplifiedHeader .redirect-link{margin:20px 0}.SimplifiedHeader .VerifiedReviews__container{display:flex}}", ""]);
// Exports
module.exports = exports;
